var map = {
	"./dtmf_#.wav": 41457,
	"./dtmf_0.wav": 56982,
	"./dtmf_1.wav": 75353,
	"./dtmf_2.wav": 48029,
	"./dtmf_3.wav": 59236,
	"./dtmf_4.wav": 93990,
	"./dtmf_5.wav": 62599,
	"./dtmf_6.wav": 26686,
	"./dtmf_7.wav": 76710,
	"./dtmf_8.wav": 60363,
	"./dtmf_9.wav": 51039,
	"./dtmf__.wav": 86279
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 87293;